export default {
  'npm_package_version': '1.30.1'
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/environments/.env.ts